import React, { useContext, useEffect } from 'react'
import useQueryParams from './useQueryParams'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { useAppDispatch, useAppSelector } from './reduxHooks'
import { verifyUserEmail } from 'actions/AuthActions'
import ModalContext from 'contexts/ModalContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import config from 'constants/config'

export function useEmailVerification() {
  const showModal = useContext(ModalContext)

  const urlSearchParams = useQueryParams()

  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectLoggedIn)

  useEffect(() => {
    if (!config.ENABLE_EMAIL_OPT_IN) return
    if (!urlSearchParams.has('token')) return

    const token = urlSearchParams.get('token')
    if (token === null) return

    dispatch(verifyUserEmail(token, isLoggedIn))

    if (!isLoggedIn) {
      showModal<AccountAccessModalResult>(<AccountAccessModal />)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlSearchParams])
}
